import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { stateType } from "../state";

import { FONTS } from "../constants";
import { LogoNameMainPageScroll } from "../dashboard/Common/LogoNameMainPageScroll";
import { isMobile } from "react-device-detect";
import { setMetaTags } from "../helpers/pageMeta";

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		policy: {
			fontFamily: FONTS,
			alignItems: "center",
			display: "flex",
			flexDirection: "column",
			width: "100vw",
		},
		policyTitle: {
			fontFamily: FONTS,
			fontSize: "40px",
			color: "black",
			marginTop: "80px",
			paddingLeft: "-500px",
		},
		logoWrapper: {
			marginLeft: "-450px",
			marginTop: "-20px",
			marginRight: "150px",
		},
		policySubTitle: {
			width: isMobile ? "90%" : "800px",
			fontSize: "30px",
			marginTop: "40px",
			color: "grey",
		},
		policyText: { width: isMobile ? "90%" : "800px", color: "grey" },
		policyText2: {
			width: isMobile ? "90%" : "800px",
			color: "grey",
			marginTop: "50px",
		},
		contact: {
			marginLeft: "0px",
			marginTop: "50px",
			cursor: "pointer",
			marginBottom: "20px",
		},
	});
});

export const TermsPage = (state: stateType) => {
	const classes = useStyles();
	function openContactUs() {
		state.state.setIsContactUsOpen(true);
	}
	useEffect(() => {
		setMetaTags();
		document.title = "Dash AI | Terms of Service";
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="App" style={{ overflow: "hidden" }}>
			<div
				className="mainSection"
				style={{
					justifyContent: "center",
					display: "flex",
					flexDirection: "row",
					height: "150px",
				}}
			>
				<div className={classes.logoWrapper}>
					<Link to="/" style={{ textDecoration: "none" }}>
						<LogoNameMainPageScroll></LogoNameMainPageScroll>
					</Link>
				</div>
				<div className={classes.policyTitle}>Terms of Use</div>
			</div>
			<div className={classes.policy}>
				<div className={classes.policyText2}>
					This page outlines an agreement between www.dash-ai.app (the
					site) and the user (you). The services offered by the site
					are conditional on acceptance of these terms below without
					modification by the user.
				</div>
				<div className={classes.policySubTitle}>Access Restriction</div>
				<div className={classes.policyText}>
					We reserve the right to restrict access to the site up to
					and including termination of an account at any time, without
					notice.
				</div>
				<div className={classes.policySubTitle}>Liability</div>
				<div className={classes.policyText}>
					THE INFORMATION SOFTWARE, PRODUCTS, AND SERVICES PUBLISHED
					ON THIS SITE MAY INCLUDE INACCURACIES OR TYPOGRAPHICAL
					ERRORS. CHANGES ARE PERIODICALLY ADDED TO THE INFORMATION
					HEREIN. IMPOVEMENTS AND/OR CHANGES IN THIS SITE MAY BE MADE
					AT ANY TIME. dash-ai.app AND ITS OWNERS MAKE NO REPRESENTAIONS
					ABOUT THE SUITABILITY OF THE INFORMATION, SOFTWARE,
					PRODUCTS, AND SERVICES CONTAINED ON THIS WEB SITE FOR ANY
					PURPOSE. ALL SUCH INFORMATION, SOFTWARE, PRODUCTS, AND
					SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND.
					dash-ai.app AND ITS OWNERS HEREBY DISCLAIM ALL WARRANTIES AND
					CONDITIONS WITH REGARD TO THIS INFORMATION, SOFTWARE,
					PRODUCTS, AND SERVICES, INCLUDING ALL IMPLIED WARRANTIES AND
					CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
					PURPOSE, TITLE AND NON-INFRINGEMENT. IN NO EVENT SHALL
					dash-ai.app OR ITS OWNERS BE LIABLE FOR AND DIRECT, INDIRECT,
					PUNITIVE, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES
					ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OF THIS
					WEB SITE OR WITH THE DELAY OR INABILITY TO USE THIS WEB
					SITE, OR OTHERWISE ARISING OUT OF THE USE OF THIS WEB SITE,
					WHETHER BASED ON CONTRACT, TORT, STRICT LIABILITY, OR
					OTHERWISE, EVEN IF DASHAI.COMIO AND ITS OWNERS HAVE BEEN
					ADVISED OF THE POSSIBILITY OF DAMAGES. BECAUSE SOME
					STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR
					LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL
					DAMAGES, THE ABOVE LIMITATION MAY NOT APPLY TO YOU.
				</div>
			</div>
		</div>
	);
};
